import { Carriers } from "@redotech/redo-model/fulfillments/fulfillment-carriers-and-services";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const createEodManifestForAll = {
  name: "createEodManifestForAll" as const,
  input: z.object({ carrier: createEnum(Carriers), addressName: z.string() }),
  output: z.object({ success: z.boolean() }),
};
